import { create } from 'zustand';
import type { ConsumableId, ConsumableLoadout, ConsumablesResponse } from '@cradle7/shared';

type State = {
  inventory: Partial<Record<ConsumableId, number>>;
  loadout: ConsumableLoadout;
};

type Actions = {
  hydrateFromServer: (payload: ConsumablesResponse) => void;
  optimisticBuy: (id: ConsumableId) => void;
  optimisticLoadout: (slots: ConsumableLoadout) => void;
  applyRunUpdate: (used: ConsumableId[], picked: ConsumableId[], outcome: 'won' | 'lost') => void;
  revert: (snapshot: ConsumablesResponse) => void;
  reset: () => void;
};

const INITIAL: State = { inventory: {}, loadout: [null, null, null] };

export const useConsumablesStore = create<State & Actions>((set, get) => ({
  ...INITIAL,
  hydrateFromServer: (p) => set({ inventory: { ...p.inventory }, loadout: [...p.loadout] }),
  optimisticBuy: (id) => set((s) => ({ inventory: { ...s.inventory, [id]: (s.inventory[id] ?? 0) + 1 } })),
  optimisticLoadout: (slots) => set({ loadout: [...slots] }),
  applyRunUpdate: (used, picked, outcome) => {
    const inv = { ...get().inventory };
    for (const id of used) inv[id] = Math.max(0, (inv[id] ?? 0) - 1);
    if (outcome === 'won') for (const id of picked) inv[id] = (inv[id] ?? 0) + 1;
    set({ inventory: inv });
  },
  revert: (snap) => set({ inventory: { ...snap.inventory }, loadout: [...snap.loadout] }),
  reset: () => set({ ...INITIAL, loadout: [...INITIAL.loadout] }),
}));
